import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { switchMap } from 'rxjs';
import { hexToRgba } from 'src/app/common/colorUtils';
import { LabelModel } from 'src/app/models/api/common';
import { LabelsHttpService } from 'src/app/services/httpServices/labelsHttpService/labels-http.service';
import { NotificationsService } from 'src/app/services/infra/notifications/notifications.service';
import { StoreService } from 'src/app/services/infra/store/store.service';

export class DeleteLabelDialogInputData {
  public label: LabelModel;
}
@Component({
  selector: 'app-delete-label-dialog',
  templateUrl: './delete-label-dialog.component.html',
  styleUrls: ['./delete-label-dialog.component.scss'],
})
export class DeleteLabelDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteLabelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: DeleteLabelDialogInputData,
    private readonly _labelsHttpService: LabelsHttpService,
    private readonly _store: StoreService,
    private readonly _notificationService: NotificationsService
  ) {}

  public onClose() {
    this.dialogRef.close();
  }

  public getLabelTransparentBackgroundColor(): string {
    return hexToRgba(this.inputData.label.color, 0.3);
  }

  public deleteButtonClick() {
    this._labelsHttpService
      .deleteLabel(this.inputData.label.id)
      .pipe(switchMap(() => this._store.updateLabels()))
      .subscribe({
        next: () => {
          this._notificationService.success('Label deleted successfully');
          this.onClose();
        },
        error: () => {
          this._notificationService.error('Failed to delete label');
        },
      });
  }
}
